import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import { Route, Switch, NavLink, Redirect, withRouter } from 'react-router-dom';
import { isEmpty } from 'lodash';

import styles from './styles';
import { getBusinessAttributes } from '../../store/actions/userProfile';
import BuilderProfileContainer from '../BuilderProfileContainer';
import ServiceAreaContainer from '../ServiceAreaContainer';
import {
  selectBusinessAttributes,
  selectUserAttributes,
} from '../../store/selectors';
import { SERVICE_AREAS } from '../../constants';
import AdditionalInformationContainer from '../AdditionalInformationContainer';

const propTypes = {
  onGetBusinessAttributes: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  businessAttributes: PropTypes.shape({
    businessNumber: PropTypes.string,
    businessName: PropTypes.string,
    businessMailingAddress: PropTypes.string,
    businessDescription: PropTypes.string,
    businessPhoneNumber: PropTypes.string,
    businessServiceAreaAddress: PropTypes.string,
    businessServiceAreaCoordinates: PropTypes.string,
    businessSkillsetBuild: PropTypes.string,
    businessSkillsetLook: PropTypes.string,
    businessPosition: PropTypes.string,
    businessApproved: PropTypes.int,
    businessServiceAreaState: PropTypes.string,
    businessServiceAreaType: PropTypes.oneOf([
      SERVICE_AREAS.LOCAL,
      SERVICE_AREAS.NATIONAL,
      SERVICE_AREAS.STATEWIDE,
    ]),
  }).isRequired,
};

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: '#333333',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    border: '1px solid #E6E8EC',
    fontSize: '0.95rem',
    lineHeight: '1.5',
    padding: '20px 20px 20px 25px',
    maxWidth: 250,
  },
}))(Tooltip);
const approvalStatusTooltipText = `Your profile is being reviewed by James Hardie Australia. We will notify you via email once our review is complete.`;
const blockedStatusTooltipText = `Your profile is deactivated.`;

export class MyBuildProfileContainer extends React.Component {
  componentDidMount() {
    const { onGetBusinessAttributes, businessAttributes } = this.props;

    if (isEmpty(businessAttributes)) {
      onGetBusinessAttributes(localStorage.getItem('accessToken'));
    }
  }

  render() {
    const {
      classes,
      location,
      businessAttributes: { businessApproved },
      userAttributes: { 'custom:roleType': roleType },
    } = this.props;

    const isBuilder = roleType === 'B';
    if (location.pathname === '/my-build-profile') {
      // Redirect to builder profile by default
      return <Redirect to="/my-build-profile/builder-profile" />;
    }

    return (
      <div className={classes.root}>
        <div className={classes.innerWrapper}>
          <div className={classes.headingContainer}>
            <h1 className={classes.heading}>myHardies Profile</h1>
            {businessApproved === 0 ? (
              <LightTooltip
                title={approvalStatusTooltipText}
                placement="bottom-start"
                PopperProps={{ className: classes.popper }}
              >
                <div className={classes.approvalStatus}>
                  <span>Pending approval</span>
                  <span>
                    <InfoIcon />
                  </span>
                </div>
              </LightTooltip>
            ) : (
              ''
            )}
            {businessApproved === 2 ? (
              <LightTooltip
                title={blockedStatusTooltipText}
                placement="bottom-start"
                PopperProps={{ className: classes.popper }}
              >
                <div className={classes.blockedStatus}>
                  <span>DEACTIVATED</span>
                  <span>
                    <InfoIcon />
                  </span>
                </div>
              </LightTooltip>
            ) : (
              ''
            )}
          </div>
        </div>
        <div className={classes.innerWrapper}>
          <ul className={classes.nav}>
            <li>
              <NavLink
                activeClassName={classes.activeLink}
                to="/my-build-profile/builder-profile"
              >
                Builder Profile
              </NavLink>
            </li>
            <li>
              <NavLink
                activeClassName={classes.activeLink}
                to="/my-build-profile/service-area"
              >
                Service Area
              </NavLink>
            </li>{' '}
            {isBuilder && (
              <li>
                <NavLink
                  activeClassName={classes.activeLink}
                  to="/my-build-profile/additional-informations"
                >
                  Additional Info
                </NavLink>
              </li>
            )}
          </ul>
        </div>
        <Switch>
          <Route
            path="/my-build-profile/builder-profile"
            component={BuilderProfileContainer}
          />
          <Route
            path="/my-build-profile/service-area"
            component={ServiceAreaContainer}
          />{' '}
          <Route
            path="/my-build-profile/additional-informations"
            component={AdditionalInformationContainer}
          />
        </Switch>
      </div>
    );
  }
}

MyBuildProfileContainer.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  businessAttributes: selectBusinessAttributes(),
  userAttributes: selectUserAttributes(),
});

const mapDispatchToProps = dispatch => ({
  onGetBusinessAttributes: accessToken =>
    dispatch(getBusinessAttributes(accessToken)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles)(MyBuildProfileContainer)),
);
